import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-stat',
    templateUrl: './stat.component.html',
    styleUrls: []
})
export class StatComponent implements OnInit {
    @Input() bgClass: string;
    @Input() icon: string;
    @Input() count: number;
    @Input() label: string;
    @Input() data: string;
    @Output() event: EventEmitter<any> = new EventEmitter();
    @Input() info:string ='';


    constructor() {

    }

    ngOnInit() {

    }
}
